"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
// This hook exists because accessibility APIs rely heavily on IDs for linking
// up components. For example, the only way to properly use `aria-labelledby` is
// to pass it the ID of a component on the page. However, you can't just put a
// static ID in case there are multiple instances on the page. So, we can just
// store a module-level variable that increments that you can then use with a
// useState hook to keep track.
var currentId = 0;
var generateId = function () {
    currentId += 1;
    return "chq-" + currentId;
};
var useId = function () {
    var _a = react_1.useState(generateId), id = _a[0], _setId = _a[1];
    return id;
};
exports.default = useId;
